//TODO: type this file
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck

import { ResourceTypes } from '@app/src/wf-constants'

export default {
  navbar: '/api/resources/account',
  intercomUserHash: '/api/resources/account/intercom-user-hash',
  accessibleOrganizations: '/api/resources/user/accessibleorganization',
  resource: (solution, resourceType, resourceId) => `/api/${solution}/${resourceType}/${resourceId}`,

  // GLOBAL RESOURCES
  requestsCollection: '/api/resources/request',
  inquiriesCollection: '/api/resources/inquiry',
  inquiriesGroupedByTemplate: '/api/resources/inquiry/groupedByTemplate',
  requestsWithFacets: '/api/resources/request/facet',
  inquiryWithFacets: '/api/resources/inquiry/facet',
  inquiryCount: '/api/resources/inquiry/count',
  inquiryById: inquiryId => `/api/resources/inquiry/${inquiryId}`,
  deleteInquiriesByIds: (inquiryId: number[], forceCompleteDeletion?: boolean) =>
    `/api/resources/inquiry/${inquiryId.join(',')}${forceCompleteDeletion ? '?forceCompleteDeletion=true' : ''}`,
  deleteScrapedResponsesByIds: (responseId: number[]) => `/api/resources/response-scraping/${responseId.join(',')}`,
  responsesCollection: '/api/resources/response',
  responsesWithFacets: '/api/resources/response/facet',
  requestItemsCollection: '/api/resources/templateQuestion',
  claims: '/api/resources/claim',
  pendingClaimsCollection: '/api/resources/claim/getAllPendingClaims',
  reviewClaims: '/api/resources/claim/bulkClaimUpdate',
  organizationsCollection: '/api/resources/organization',
  getMyOrganization: `/api/resources/organization/get-my-organization`,
  updateOwnOrganization: `/api/resources/organization/update-own-organization`,
  updateOwnOrganizationImage: `/api/resources/organization/update-own-organization-image`,
  potentialDuplicates: (
    name: string,
    website?: string,
    vatNumber?: string,
    address?: string,
    registrationNumber?: string,
  ) => {
    const queryParams = new URLSearchParams({
      name: name,
      ...(website?.trim()?.length ? { website: website } : {}),
      ...(vatNumber?.trim()?.length ? { vatNumber: vatNumber } : {}),
      ...(address?.trim()?.length ? { address: address } : {}),
      ...(registrationNumber?.trim()?.length ? { registrationNumber: registrationNumber } : {}),
    })
    return `/api/resources/organization/potential-duplicates?${queryParams.toString()}`
  },
  contactsCollection: '/api/resources/contact',
  contactsWithFacets: '/api/resources/contact/facet',
  saveContact: '/api/resources/contact/save',
  deleteContact: id => `/api/resources/contact/delete/${id}`,
  notifications: '/api/resources/notification',
  notificationsWithFacets: '/api/resources/notification/facet',
  markNotificationsAsSeen: '/api/resources/notification/markseen',
  user: userId => `/api/resources/user/${userId}`,
  unsetReferralCodeForUser: `/api/resources/user/unsetReferralCode`,
  setReferralCodeForUser: referralCode => `/api/resources/user/setReferralCode/${referralCode}`,
  sendVerificationEmail: '/api/resources/user/resend-verification-email',
  naceCodes: '/api/resources/nacecode',
  naceCodesWithFacets: '/api/resources/nacecode/facet',
  evaluationsCollection: '/api/resources/datapoint',
  evaluationsWithFacets: '/api/resources/datapoint/facet',
  frameworks: '/api/resources/framework',
  frameworksWithFacets: '/api/resources/framework/facet',
  frameworkIndicators: '/api/resources/framework/indicator',
  frameworkIndicatorsWithFacets: '/api/resources/framework/indicator/facet',
  countries: '/api/resources/country',
  countriesWithFacets: '/api/resources/country/facet',
  riskPrioritization: '/api/resources/risk/prioritization',
  riskPrioritizationWithFacets: '/api/resources/risk/prioritization/facet',

  // REMINDERS
  sendRequestReminders: '/api/requestReminder/send-request-reminder',

  // DATAHUB
  responseItemsCollection: '/api/resources/response/items',
  responseItemsWithFacets: '/api/resources/response/items/facet',
  responseItemCount: '/api/resources/response/items/count',
  responseItemsWithStatisticsByQuestions: '/api/resources/response/items/statistics/statisticsByQuestions',
  dataInsightsByQuestions: '/api/resources/response/items/statistics/dataInsightsQuestions',
  previousAnswers: '/api/resources/response/items/previous-answers',

  findingsProviders: '/api/resources/findings/providers',
  findingsOverview: '/api/resources/findings/overview',

  platformReleases: '/api/platform-releases',

  subscriptions: '/api/resources/request/subscription',
  subscriptionsFacets: '/api/resources/request/subscription/facet',

  // PROVIDERS COLLECTIONS
  providersCollection: '/api/resources/provider',
  providersWithFacets: '/api/resources/provider/facet',
  providerCount: '/api/resources/provider/count',
  provider: providerId => `/api/resources/provider/${providerId}`,
  providerActivity: '/api/resources/provider/activity',
  providerRiskRating: '/api/resources/provider/riskRating',
  linkOrganizationWithProvider: '/api/resources/provider/link-organization-with-provider',
  bulkLinkOrganizationsWithProviders: '/api/resources/provider/bulk-link-organizations-with-providers',
  providerActivityByType: (providerId, activityType) =>
    `/api/resources/provider/${providerId}/activity?type=${activityType}`,
  providerSpendHistoryImportFileDownload: '/api/resources/provider/bulk-update-export',
  providerSpendHistoryImport: '/api/resources/provider/bulk-update-file',
  providerAnnualSpendDelete: spendId => `/api/resources/provider/spend/${spendId}`,
  providerAnnualSpendSave: '/api/resources/provider/spend/save',
  scheduleScreening: '/api/resources/provider/schedule-screening',
  myProfile: '/api/resources/myprofile',
  generateMyProfile: '/api/resources/myprofile/generate',
  scheduleEnrichment: '/api/resources/provider/schedule-enrichment',

  //PRODUCTS
  productsCollection: '/api/resources/product/filter',
  productCount: '/api/resources/product/count',
  productsWithFacets: '/api/resources/product/facet',
  saveProduct: '/api/resources/product',
  product: id => `/api/resources/product/${id}`,
  deleteProduct: id => `/api/resources/product/delete/${id}`,
  bulkDeleteProducts: (ids: number[]) => `/api/resources/product/${ids.join(',')}`,
  updateProducts: '/api/resources/product/bulkUpdate',
  patchProduct: productId => `/api/resources/product/${productId}`,
  mappingNodeCollection: '/api/resources/MappingNode/filter',
  mappingNodeWithFacets: '/api/resources/MappingNode/facet',
  mappingNode: '/api/resources/MappingNode',
  saveValueChain: '/api/resources/MappingNode/saveValueChain',
  mappingNodeById: id => `/api/resources/MappingNode/${id}`,
  deleteMappingNode: id => `/api/resources/MappingNode/delete/${id}`,
  productMappingRequest: id => `/api/resources/ProductMappingRequest/${id}`,
  productMappingRequests: '/api/resources/ProductMappingRequest/filter',
  saveProductMappingRequest: '/api/resources/productMappingRequest',
  mappingRequestCollection: '/api/resources/ProductMappingRequest/filter',
  mappingRequestsWithFacets: '/api/resources/ProductMappingRequest/facet',
  mappingRequestCount: '/api/resources/ProductMappingRequest/count',
  productMappingRequestByIds: (mappingRequestIds: number[]) =>
    `/api/resources/ProductMappingRequest/${mappingRequestIds.join(',')}`,
  productMappingResponse: '/api/resources/productMappingResponse',
  productMappingResponseCollection: '/api/resources/productMappingResponse/filter',
  submitProductMappingResponse: id => `/api/resources/productMappingResponse/${id}/submit`,
  deleteProductMappingResponse: id => `/api/resources/productMappingResponse/${id}`,
  cloneProductMappingResponse: `/api/resources/productMappingResponse/clone`,
  unlinkProductMappingResponse: (id: number) => `/api/resources/productMappingResponse/${id}/unlink`,
  copyValueChainFromNode: '/api/resources/MappingNode/copyValueChainFromNode',
  copyValueChainFromResponse: '/api/resources/MappingNode/copyValueChainFromResponse',
  mappingResponseConnections: id => `/api/resources/productMappingResponse/${id}/connections`,
  mappingResponseCollection: '/api/resources/ProductMappingResponse/filter',
  mappingResponseWithFacets: '/api/resources/ProductMappingResponse/facet',
  mappingResponseCount: '/api/resources/ProductMappingResponse/count',
  actorTypesCollection: '/api/resources/actortype/filter',
  ActorTypesWithFacets: '/api/resources/actortype/facet',

  // TRANSPARENCY/REPORTING
  requests: '/api/resources/request',
  request: (requestId, language) => `/api/resources/request/${requestId}${language ? `?language=${language}` : ''}`,
  response: (responseId, language, includePreviousCorrections) => {
    const queryParams = new URLSearchParams()
    if (language) queryParams.append('language', language)
    if (includePreviousCorrections) queryParams.append('include-previous-corrections', 'true')
    return `/api/resources/response/${responseId}?${queryParams.toString()}`
  },
  responses: '/api/resources/response',
  responsesCount: '/api/resources/response/count',
  createResponseDraft: `/api/resources/response/createDraft`,
  updateResponseDraft: `/api/resources/response/updateDraft`,
  submitResponseDraft: `/api/resources/response/submitDraft`,
  submitResponse: `/api/resources/response/submit`,
  submitPublicReport: `/api/resources/report/submit`,
  getAccessForReport: requestId => `/api/resources/report/accessors/${requestId}`,
  getAccessForMultipleReports: requestIdsParams => `/api/resources/report/accessors?${requestIdsParams}`,
  getAccessForMultipleReports2: '/api/resources/report/accessors',
  assignAccessors: '/api/resources/report/assignaccessor',
  getOrCreateReport: '/api/resources/report/getorcreate',
  saveResponse: '/api/resources/response/save',
  setResponseReviewMessage: '/api/resources/response/reviewMessage',
  responseInternalVerification: '/api/resources/response/internal-verification',
  responseItemInternalVerification: '/api/resources/response/items/internal-verification',
  reuseResponse: (requestId, responseId) =>
    `/api/resources/response/clone?requestId=${requestId}&responseId=${responseId}`,
  reuseFile: (originalResponseItemId, newResponseItemId) =>
    `/api/resources/response/items/cloneFileItem?originalResponseItemId=${originalResponseItemId}&newResponseItemId=${newResponseItemId}`,
  verifyResponseItem: '/api/resources/response/items/verify',
  discardResponse: responseId => `/api/resources/response/delete/${responseId}`,
  accessors: '/api/resources/accessor',
  requestHistory: requestId => `/api/resources/request/history/${requestId}`,
  downloadResponse: (responseId, languageCode) =>
    `/api/resources/response/download/${responseId}/${languageCode ? `?languageCode=${languageCode}` : ''}`,

  // FILES
  fileUpload: (sourceObjectId, sourceObjectType) =>
    `/file-management/file/upload?sourceObjectId=${sourceObjectId}&sourceObjectType=${sourceObjectType}`,
  fileDownload: id => `/file-management/file/${id}`,
  exportDownload: id => `/file-management/export/${id}`,
  deleteFile: id => `/file-management/file/singleDelete/${id}`,
  filesBySourceObject: '/file-management/file/getBySourceObject',
  uploadImage: '/file-management/file/uploadimage',

  //PROVIDER COMMENTS
  providerComments: '/api/resources/provider/comment',
  providerCommentById: id => `/api/resources/provider/comment/${id}`,

  // SAVE RESOURCES
  saveResource: (solution, resourceType) => `/api/${solution}/${resourceType}/save`,
  saveResourceInBulk: resourceType => `/api/resources/${resourceType}/bulk/save`,
  password: `/api/resources/user/password`,

  // DELETE RESOURCES
  deleteResource: (solution, resourceType, resourceId) => {
    if (resourceType === ResourceTypes.Colleague || resourceType === ResourceTypes.User)
      return `/api/resources/account/solution/members/delete/${resourceId}`

    return `/api/${solution}/${resourceType}/delete/${resourceId}`
  },

  // CONFIGURATIONS
  requestTemplates: '/api/resources/request/template',
  updateQuestionnaireTemplateAvailability: id => `/api/resources/request/template/${id}/availability`,
  sharedAndOwnedTemplates: '/api/resources/request/template/sharedAndOwnedTemplates',
  worldfavorTemplates: '/api/resources/request/template/worldfavortemplates',
  adverseScreeningTemplates: '/api/resources/request/template/adversescreeningtemplates',
  worldfavorTemplatesWithRecommendation: '/api/resources/request/template/worldfavortemplateswithrecommendation',
  recommendedWorldfavorTemplates: '/api/resources/request/template/recommendedworldfavortemplates',
  worldfavorAndCustomTemplates: '/api/resources/request/template/worldfavorandcustomtemplates',
  worldfavorTemplatesFacets: '/api/resources/request/template/worldfavortemplatesfacet',
  recommendedWorldfavorTemplatesFacets: '/api/resources/request/template/recommendedworldfavortemplatesfacet',
  auditLogs: '/api/utility/auditlog',
  colleagues: '/api/resources/user/colleagues',
  saveSolutionMembership: '/api/resources/account/solution/members/save',
  solutionOrganizations: '/api/resources/account/solution/organization-solution',
  invitations: '/api/resources/invitation',
  templateById: (templateId, isStandard = false) =>
    `/api/resources/request/template/${templateId}?isStandard=${isStandard}`,
  publishTemplate: templateId => `/api/resources/request/template/${templateId}/publish`,
  unpublishTemplate: templateId => `/api/resources/request/template/${templateId}/unpublish`,
  saveTemplate: '/api/resources/request/template/save',
  saveTemplateStaff: '/api/resources/request/template/save-staff',
  defaultSystemPrompt: (scrapingType: string) =>
    `/api/resources/request/template/default-system-prompt/${scrapingType}`,
  savePicker: '/api/resources/request/template/requestcollection/save',
  deleteTemplate: templateId => `/api/resources/request/template/delete/${templateId}`,
  units: '/api/resources/unit',
  pickers: '/api/resources/request/template/requestcollection',
  organizationOwnedTemplates: '/api/resources/request/template/organizationownedtemplates',
  userManagement: '/api/resources/useradmin',
  actualUserCounts: '/api/resources/useradmin/actual-user-counts',
  organizationsExceedingContract: '/api/resources/useradmin/organizations-exceeding-contract',
  actualSupplierCounts: '/api/resources/organization/actual-supplier-counts',
  organizationsExceedingSupplierContract: '/api/resources/organization/organizations-exceeding-supplier-contract',

  questionCollection: '/api/resources/question/filter',
  questionWithFacets: '/api/resources/question/facet',
  saveQuestion: '/api/resources/question',
  saveQuestionStaff: '/api/resources/question/save-staff',
  deleteQuestion: id => `/api/resources/question/delete/${id}`,
  questionById: questionId => `/api/resources/question/${questionId}`,

  questionCategoryOptionCollection: '/api/resources/questionCategoryOption/filter',
  questionCategoryOption: '/api/resources/questionCategoryOption',
  questionCategoryCollection: '/api/resources/questionCategory/filter',
  questionCategory: '/api/resources/questionCategory',

  // EXPORT
  exportData: resourceType => `/api/resources/${resourceType}/export`,
  queueDataExport: resourceType => `/api/resources/${resourceType}/queueExport`,
  queueResponseItemsExport: `/api/resources/response/items/queueExport`,
  saveExcelExportSettings: '/api/ExcelExportSettings/Save',
  excelExportSettings: (resourceType, resourceView) =>
    `/api/ExcelExportSettings?resourceType=${resourceType}&resourceView=${resourceView}`,
  deleteExcelExportSettings: id => `/api/ExcelExportSettings/${id}`,

  // IMPORT
  importData: (solution, resourceType) => `/api/${solution}/${resourceType}/import`,

  //RISK
  topicalRisk: '/api/resources/providerRisk',
  sustainabilityTopics: '/api/resources/sustainabilityTopic/filter',
  providerRiskWithFacets: '/api/resources/providerRisk/facet',
  providerRiskCount: '/api/resources/providerRisk/count',
  providerRiskTotalSpendAtRisk: '/api/resources/providerRisk/getTotalSpendAtRisk',
  providerRiskTotalSpendAtRiskAggregate: '/api/resources/providerRisk/getTotalSpendAtRiskAggregate',
  providerRiskDistributionTrend: '/api/resources/providerRisk/riskDistributionTrend',
  calculateAllProviderRisks: '/api/resources/providerRisk/calculate-all-provider-risks',
  recalculateOrganizationFlags: '/api/resources/report/flag/recalculate-organization-flags',
  riskScreening: '/api/resources/risk-screening',
  riskScreeningHqRiskStatusFacet: '/api/resources/risk-screening/FacetHqRiskStatus',
  riskScreeningHqProviderFacet: '/api/resources/risk-screening/FacetHqProvider',
  riskScreeningAllRisks: '/api/resources/risk-screening',
  riskScreeningAllRisksRiskStatusFacet: '/api/resources/risk-screening/all-risk/facetRiskStatus',
  riskScreeningAllRisksProviderFacet: '/api/resources/risk-screening/provider/facet',
  riskScreeningProviderRisks: '/api/resources/risk-screening/provider-risks',

  //Referral
  generateReferralCode: '/api/resources/referral',
  referralCode: guid => `/api/resources/referral/${guid}`,
  linkWithReferrer: '/api/resources/referral/linkWithReferrer',
  getReferralCollection: '/api/resources/referral/GetCollection',
  bulkFindOrganizations: '/api/resources/referralContact/find-if-exists',
  bulkFindExactMatches: '/api/resources/referralContact/find-exact-matches',

  //Find organization
  findOrganization: query => `/api/resources/provider/find?q=${encodeURIComponent(query)}`,
  //Get organization
  organization: id => `/api/resources/organization/${id}`,
  transferOrganization: '/api/resources/organization/transfer',

  //Admin
  organizations: '/api/resources/organization/',
  organizationDelete: id => `/api/resources/organization/${id}`,
  assignSolution: '/api/resources/account/solution/create',

  // Provider
  saveProvider: '/api/resources/provider/save',
  updateProviders: '/api/resources/provider/bulkUpdate',
  suggestedContact: '/api/resources/suggestedContact',
  acceptSuggestedContact: id => `/api/resources/suggestedContact/accept/${id}`,
  rejectSuggestedContact: id => `/api/resources/suggestedContact/reject/${id}`,
  bulkDeleteProviders: (ids: number[]) => `/api/resources/provider/${ids.join(',')}`,

  //Automated sendouts
  automations: '/api/resources/request/template/automation',
  automationsWithFacets: '/api/resources/request/template/automation/facet',
  saveAutomation: '/api/resources/request/template/automation/save',
  deleteAutomation: automationId => `/api/resources/request/template/automation/${automationId}`,
  deactivateAutomation: automationId => `/api/resources/request/template/automation/${automationId}/deactivate`,
  affectedAutomationCount: '/api/resources/request/template/automation/affectedProviderCount',
  eligibleEnrichmentCount: '/api/resources/request/template/automation/eligibleEnrichmentCount',
  eligibleScreeningCount: '/api/resources/request/template/automation/eligibleScreeningCount',

  //Category
  category: '/api/resources/category',
  categoriesWithIncludes: '/api/resources/category/getWithIncludes',
  categoryGetWithIds: '/api/resources/category/getWithIds',
  categoryById: categoryId => `/api/resources/category/${categoryId}`,
  categoryOptionsByCategory: categoryId => `/api/resources/category/${categoryId}/categoryOptions`,
  categoryOption: `/api/resources/categoryOption`,
  categoryOptionById: categoryOptionId => `/api/resources/categoryOption/${categoryOptionId}`,

  //Export template
  exportTemplateCollection: '/api/resources/exporttemplate',

  availableLanguageTranslation: '/api/resources/language/availablelanguagetranslations',

  //Flags
  reportFlags: '/api/resources/report/flag',
  saveReportFlag: '/api/resources/report/flag/save',
  activateReportFlag: requestItemTemplateId => `/api/resources/report/flag/activation/${requestItemTemplateId}`,
  deactivateReportFlag: requestItemTemplateId => `/api/resources/report/flag/deactivation/${requestItemTemplateId}`,
  deleteReportFlag: reportFlagId => `/api/resources/report/flag/${reportFlagId}`,

  //SuggestedRiskGuidance
  deleteSuggestions: id => `/api/resources/report/flag/suggested-risk-guidance/${id}`,
  removeSuggestedGuidanceLink: id => `/api/resources/report/flag/suggested-risk-guidance/remove-link/${id}`,

  // Answer flag rules
  answerFlagRuleCollection: '/api/resources/answerFlagRule/filter',
  answerFlagRuleFacets: '/api/resources/answerFlagRule/facet',
  saveAnswerFlagRule: '/api/resources/answerFlagRule',
  answerFlagRuleById: (id: number) => `/api/resources/answerFlagRule/${id}`,
  deleteAnswerFlagRule: (id: number) => `/api/resources/answerFlagRule/${id}`,

  //GoalTracker
  createGoalTracker: '/api/resources/progressgoal',
  goalTrackerCollection: '/api/resources/progressgoal/filter',
  deleteGoalTracker: id => `/api/resources/progressgoal/remove/${id}`,

  //Questionnaire statistics
  overviewStatistics: '/api/statistics/questionnaire/overview-statistics',
  requestOverviewStatisticsInProgress: '/api/statistics/questionnaire/request-progress-statistics/in-progress',
  requestOverviewStatisticsCompleted: '/api/statistics/questionnaire/request-progress-statistics/completed',
  companyOverviewStatisticsInProgress: '/api/statistics/questionnaire/company-progress-statistics/in-progress',
  companyOverviewStatisticsCompleted: '/api/statistics/questionnaire/company-progress-statistics/completed',

  // Organization settings
  organizationSettings: '/api/resources/organization/settings',
  dueDiligenceIntent: '/api/resources/duediligenceintent',
  organizationCsmSettings: '/api/resources/organization/csm-settings',
  organizationCsmSettingsById: (organizationId: number, solutionType) =>
    `/api/resources/organization/${organizationId}/${solutionType}/csm-settings`,
  organizationEntitlements: (organizationId: number) => `/api/resources/entitlement/organization/${organizationId}`,
  organizationEntitlementsBySolution: (organizationId: number, solutionType: string) =>
    `/api/resources/entitlement/organization/${organizationId}/${solutionType}`,
  entitlementPolicies: '/api/resources/entitlement/policy',
  scopeEntitlements: (feature: string, scopeId: number) =>
    `/api/resources/entitlement/scope/${feature}/${scopeId}/organization`,
  organizationRiskSettings: '/api/resources/OrganizationRiskSetting',
  organizationAssessmentSettings: '/api/resources/OrganizationAssessment',
  reEvaluateAssessmentsByTemplate: '/api/resources/OrganizationAssessment/reEvaluateAssessmentsByTemplate',
  organizationAssessmentSettingsFacet: '/api/resources/OrganizationAssessment/facet',
  suggestedResponse: questionType => `/suggestions/${questionType}`,
  suggestionFiles: '/suggestions/files',
  suggestionFileNames: '/suggestions/files/names',
  suggestionFile: name => `/suggestions/files/${encodeURIComponent(name)}`,

  // Referral contact
  referralContactCollection: '/api/resources/referralContact/filter',
  saveReferralContact: '/api/resources/referralContact',
  sendBulkInviteToReferralContacts: '/api/resources/referralContact/send-bulk-invite',
  deleteReferralContact: id => `/api/resources/referralContact/remove/${id}`,

  // Base assessment
  assessmentFilterOwnOrganization: '/api/resources/assessment/filter-own-organization',
  assessmentCollection: '/api/resources/assessment/filter',
  assessmentFacet: '/api/resources/assessment/facet',
  assessmentCount: '/api/resources/assessment/count',
  assessmentQuestionnaireLink: '/api/resources/assessmentQuestionnaireLink/filter',
  assessmentTemplateCollection: '/api/resources/assessmentTemplate/filter',
  assessmentTemplate: '/api/resources/assessmentTemplate',
  updateAssessmentTemplateAvailability: id => `/api/resources/assessmentTemplate/${id}/availability`,
  deleteAssessmentTemplate: id => `/api/resources/assessmentTemplate/remove/${id}`,
  questionAnswerClassificationRule: '/api/resources/QuestionAnswerClassificationRule',
  getAssessmentTemplateRiskIndices: assessmentTemplateId =>
    `/api/resources/assessmentTemplate/GetAssessmentTemplateRiskIndices/${assessmentTemplateId}`,

  // Benchmarks
  calculateBenchmarks: '/api/resources/benchmark/recalculate',
  assessmentBenchmarkCollection: '/api/resources/assessmentbenchmark/filter',
  assessmentBenchmarkFacets: '/api/resources/assessmentbenchmark/facet',
  findingsBenchmarkCollection: '/api/resources/findingsbenchmark/filter',
  findingsBenchmarkFacets: '/api/resources/findingsbenchmark/facet',
  sustainabilityProfileBenchmark: (providerId: number, groupType: string) =>
    `/api/resources/sustainabilityprofilebenchmark?providerId=${providerId}&groupType=${groupType}`,

  // Share data feedback
  submitShareDataFeedback: '/api/resources/userFeedback/submit-share-data-feedback',

  anyAccessorHasFeature: (featureToggleName: string) =>
    `/api/utility/featuretoggle/any-accessor-has-feature?featureToggle=${featureToggleName}`,
  assessmentTemplateRiskIndices: assessmentTemplateId =>
    `/api/resources/assessmentTemplate/getAssessmentTemplateRiskIndices/${assessmentTemplateId}`,
  assessmentTemplateWithClassificationRules: id => `/api/resources/assessmentTemplateWithClassificationRules/${id}`,
  assessmentTemplateQuestionnaireSyncStatus: id => `/api/resources/assessmentTemplate/${id}/questionnaire-sync-status`,
  assessmentTemplateQuestionnaireSync: id => `/api/resources/assessmentTemplate/${id}/questionnaire-sync`,

  scraperRunning: '/api/resources/response-scraping/scraper-running',
  responseScraping: '/api/resources/response-scraping',
  responseScrapingFacet: '/api/resources/response-scraping/facet',
  responseScrapingAdminFilter: '/api/resources/response-scraping/admin-filter',
  responseScrapingAdminFacet: '/api/resources/response-scraping/admin-facet',
  responsesScrapingCount: '/api/resources/response-scraping/count',
  scrapedAnswers: '/api/resources/scrapedAnswer/filter',
  discardAiAnswer: (responseItemId: number) => `/api/resources/response/item/${responseItemId}/discard-ai-answer`,

  //Insights Report
  insightsReports: (azureTranslatorLanguageCode: string) =>
    `/api/resources/insightsReport/filter?azureTranslatorLanguageCode=${azureTranslatorLanguageCode}`,
  insightsReportItem: (insightsReportItemId: number) => `/api/resources/insightsReportItem/${insightsReportItemId}`,
  dueDiligenceReports: (azureTranslatorLanguageCode: string) =>
    `/api/resources/dueDiligenceReport/filter?azureTranslatorLanguageCode=${azureTranslatorLanguageCode}`,

  // Tabular import (entityType: 'provider' | 'product')
  tabularImportInitiate: (entityType: string) => `/api/tabular-import/${entityType}/initiate`,
  tabularImportSessions: (entityType: string) => `/api/tabular-import/${entityType}/sessions`,
  tabularImportSession: (entityType: string, sessionId: string) => `/api/tabular-import/${entityType}/${sessionId}`,
  tabularImportStatus: (entityType: string, sessionId: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/status`,
  tabularImportRecords: (entityType: string, sessionId: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/records`,
  tabularImportRecord: (entityType: string, sessionId: string, rowNumber: number) =>
    `/api/tabular-import/${entityType}/${sessionId}/records/${rowNumber}`,
  tabularImportReady: (entityType: string, sessionId: string) => `/api/tabular-import/${entityType}/${sessionId}/ready`,
  tabularImportSetStatus: (entityType: string, sessionId: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/set-status`,
  tabularImportImport: (entityType: string, sessionId: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/import`,
  tabularImportMappings: (entityType: string, sessionId: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/mappings`,
  tabularImportMappingTarget: (entityType: string, sessionId: string, mappingId: number) =>
    `/api/tabular-import/${entityType}/${sessionId}/mappings/${mappingId}/target`,
  tabularImportMappingSplit: (entityType: string, sessionId: string, mappingId: number) =>
    `/api/tabular-import/${entityType}/${sessionId}/mappings/${mappingId}/split`,
  tabularImportApproveMappings: (entityType: string, sessionId: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/approve-mappings`,
  tabularImportDeduplicationSummary: (entityType: string, sessionId: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/deduplication-summary`,
  tabularImportDeduplicationResults: (entityType: string, sessionId: string, search: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/deduplication-results?${search}`,
  tabularImportDeduplicationBulkAction: (entityType: string, sessionId: string) =>
    `/api/tabular-import/${entityType}/${sessionId}/deduplication-results/bulk-action`,
  tabularImportDeduplicationDecision: (entityType: string, id: number) =>
    `/api/tabular-import/${entityType}/deduplication-result/${id}`,
  tabularImportDeduplicationAssign: (entityType: string, id: number) =>
    `/api/tabular-import/${entityType}/deduplication-result/${id}/assign`,
  tabularImportRecordAssign: (entityType: string, sessionId: string, rowNumber: number) =>
    `/api/tabular-import/${entityType}/${sessionId}/records/${rowNumber}/assign`,
  tabularImportRecordSetAction: (entityType: string, sessionId: string, rowNumber: number) =>
    `/api/tabular-import/${entityType}/${sessionId}/records/${rowNumber}/set-action`,
  // Provider-only tabular import endpoints
  tabularImportNewProviderIds: (sessionId: string) => `/api/tabular-import/provider/${sessionId}/new-provider-ids`,
  tabularImportMappingConvertToCategory: (sessionId: string, mappingId: number) =>
    `/api/tabular-import/provider/${sessionId}/mappings/${mappingId}/convert-to-category`,
  tabularImportCategoryToColumns: (sessionId: string) =>
    `/api/tabular-import/provider/${sessionId}/category-to-columns`,
  tabularImportCategoryPlan: (sessionId: string) => `/api/tabular-import/provider/${sessionId}/category-plan`,

  //Expectations
  expectationAutomation: '/api/resources/expectation/automation',
  expectationAutomationFilter: '/api/resources/expectation/automation/filter',
  expectationAutomationById: (automationId: number) => `/api/resources/expectation/automation/${automationId}`,
  deleteExpectationAutomation: (automationId: number) => `/api/resources/expectation/automation/${automationId}`,
  expectationAutomationAffectedCount: '/api/resources/expectation/automation/affectedProviderCount',
  expectationCollection: '/api/resources/expectation/filter',
  expectationWithFacets: '/api/resources/expectation/facet',
  bulkCreateExpectation: '/api/resources/expectation/bulk',
  expectation: expectationId => `/api/resources/expectation/${expectationId}`,
  deleteExpectationsByIds: (ids: number[]) => `/api/resources/expectation/${ids.join(',')}`,
  bulkUpdateExpectationDeadline: '/api/resources/expectation/bulk/deadline',
  updateExpectationStatus: '/api/resources/expectation/updateStatus',

  //Saved table views
  savedViews: '/api/saved-views',
  savedView: (id: number) => `/api/saved-views/${id}`,
}
